<template>
    <a
        v-if="externalCheckoutData && externalCheckoutData.url"
        :href="externalCheckoutData.url"
        class="variant-flat netto-block__footer"
        @click="$emit('variantSelected', variant)"
    >
        <div class="row no-gutters">
            <div class="col pr-2">
                <div
                    v-if="variant.duration || variant.selectionText"
                    class="netto-block__provider netto-block__footer-provider mb-2"
                >
                    {{ variant.duration || variant.selectionText }}
                </div>

                <MarketingHint
                    v-if="variant.marketingHint"
                    :marketingHint="variant.marketingHint"
                    class="netto-marketing-hint variant-flat__hint"
                />
            </div>

            <template v-if="externalCheckoutData.priceText">
                <div class="netto-price variant-price netto-block__price col-auto">
                    <div class="netto-price__wrapper">
                        <div class="price-value package-price d-block external-price-text">
                            {{ externalCheckoutData.priceText }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <NettoPrice
                    v-if="price"
                    :minimumPrice="price.price"
                    :list-price="price.listPrice"
                    ignore-price-mode
                    :prefix="isAuctionOffer ? 'Wert' : isVoucher ? 'Nur' : undefined"
                    hide-help
                    :class="
                        isAuctionOffer
                            ? 'variant-price netto-block__price col-auto auction-price'
                            : 'variant-price netto-block__price col-auto'
                    "
                ></NettoPrice>
            </template>
        </div>

        <button type="button" class="btn btn-outline-primary netto-block__offer-button">
            {{ externalCheckoutData.buttonText || 'Zum Partnershop' }}
        </button>
    </a>
    <nuxt-link
        v-else
        :to="nettoLink"
        class="variant-flat netto-block__footer"
        @click.native="$emit('variantSelected', variant)"
    >
        <div class="row no-gutters">
            <div class="col pr-2">
                <div
                    v-if="variant.duration || variant.selectionText"
                    class="netto-block__provider netto-block__footer-provider mb-2"
                >
                    {{ variant.duration || variant.selectionText }}
                </div>

                <MarketingHint
                    v-if="variant.marketingHint"
                    :marketingHint="variant.marketingHint"
                    class="netto-marketing-hint variant-flat__hint"
                />
            </div>

            <NettoPrice
                v-if="price"
                :minimumPrice="price.price"
                :list-price="price.listPrice"
                ignore-price-mode
                :prefix="isAuctionOffer ? 'Wert' : isVoucher ? 'Nur' : undefined"
                hide-help
                :class="
                    isAuctionOffer
                        ? 'variant-price netto-block__price col-auto auction-price'
                        : 'variant-price netto-block__price col-auto'
                "
            ></NettoPrice>
        </div>

        <button type="button" class="btn btn-outline-primary netto-block__offer-button" v-if="isAuctionOffer">
            Jetzt bieten
        </button>
        <button type="button" class="btn btn-outline-primary netto-block__offer-button" v-else>In den Warenkorb</button>
    </nuxt-link>
</template>

<script>
import VariantItem from '@/components/product/selection/VariantItemFlat.vue';
import NettoPrice from '@/themes/nettovorteilswelt/components/NettoPrice';

export default {
    name: 'NettoVariantItem',
    components: { NettoPrice },
    extends: VariantItem,
    computed: {
        nettoLink() {
            const link = this.link;
            link.query.mobileTeaser = true;
            return link;
        }
    }
};
</script>

<style scoped lang="scss">
@use '../../styles/variables' as theme;

.netto-price {
    font-family: 'FrankfurterNetto', sans-serif;
    min-width: 90px;
    text-align: center;
    display: inline-block;
    position: relative;

    .price-value {
        background: theme.$primary;
        color: hsl(0, 0%, 100%);
        font-weight: bold;
        line-height: 32px;
    }

    .external-price-text {
        padding: 0 2px;
    }
}
.netto-marketing-hint {
    border-radius: 100px;
    font-size: 13px;
}
</style>
